import modulePaths from 'constants/modulePath';
import moduleCodes from 'constants/moduleCodes';
import routePath from 'constants/routePath';

export const get2bapProfilesModuleUrl = () =>
  `/${modulePaths[moduleCodes.MODULE_2BAP]}/${routePath.ROUTE_2BAP_EXTERNAL_PROFILE_MODULE}`;

export const getProfilesSummaryViewUrl = () =>
  `${get2bapProfilesModuleUrl()}/${routePath.ROUTE_2BAP_EXTERNAL_PROFILE_SUMMARY_VIEW}`;

export const isModuleIndexPage = (url = window.location.pathname) => (
  url === get2bapProfilesModuleUrl() || url === getProfilesSummaryViewUrl()
);

export const getProfilesSummaryEditUrl = () =>
  `${get2bapProfilesModuleUrl()}/${routePath.ROUTE_2BAP_EXTERNAL_PROFILE_SUMMARY_EDIT}`;

const getEntityEditPrefixUrl = () =>
  `${get2bapProfilesModuleUrl()}/${routePath.ROUTE_2BAP_EXTERNAL_EDIT_ENTITY_PREFIX}`;

export const getClassEditUrl = (id) =>
  `${getEntityEditPrefixUrl()}/${routePath.ROUTE_2BAP_EXTERNAL_PROFILE_CLASS_EDIT}${id ? `/${id}` : ''}`;

export const getLearnerEditUrl = (classId, learnerId) =>
  `${getClassEditUrl(classId)}/${routePath.ROUTE_2BAP_EXTERNAL_PROFILE_LEARNER_EDIT}${learnerId ? `/${learnerId}` : ''}`;

export const getLearnerProfilePageUrl = (learnerId) =>
  `${get2bapProfilesModuleUrl()}/${routePath.ROUTE_2BAP_EXTERNAL_PROFILE_LEARNER_PROFILE}/${learnerId}`;

export const get2bapProfilesAuthErrorUrl = () => `/${routePath.ROUTE_2BAP_EXTERNAL_PROFILE_MODULE_AUTH_ERROR}`;
